import { SHARED_ROUTES } from '@aibees/shared/constants';
import { classnames } from '@aibees/shared/utils';
import { memo } from 'react';
import { useLocation } from 'react-router-dom';
import { PaymentBar } from './components/payment-bar';
import { PlanExpiredBar } from './components/plan-expired-bar';
import { SubscriptionBar } from './components/subscription-bar';
import * as Styled from './styles';
import type { GlobalNotificationBarProps as Props } from './types';

export const GlobalNotificationBar = memo(({ className }: Props) => {
  const { pathname } = useLocation();

  if (pathname === SHARED_ROUTES.priceAndPlan) return null;

  return (
    <Styled.Wrapper className={classnames('GlobalNotificationBar', className)}>
      <SubscriptionBar />
      <PaymentBar />
      <PlanExpiredBar />
    </Styled.Wrapper>
  );
});

GlobalNotificationBar.displayName = 'GlobalNotificationBar';
